// extracted by mini-css-extract-plugin
module.exports = {"root":"Page_root__lwqX9","content":"Page_content__33tYG","scrollingDisabled":"Page_scrollingDisabled__2NxeL"};